import React, {useState} from "react";
import Styles from "./Gallery.module.css";
import {Link} from "react-router-dom";
import Next_Btn from "./Subpage/Next_Btn";

export const NextGallery1 = () => {
  const [images, setImages] = useState([
    {id: 41, src: "../assets/images/2021.jpg", caption: "2021"},
    {id: 42, src: "../assets/images/2022.jpg", caption: "2022"},
    {id: 45, src: "../assets/images/2024g1.jpg", caption: "2024"},
    {id: 34, src: "../assets/images/2015anotherpic.jpg", caption: "2015"},
    {id: 40, src: "../assets/images/2020.jpg", caption: "2020"},
    {id: 46, src: "../assets/images/2024g2.jpg", caption: "2024"},
    {id: 53, src: "../assets/images/2024g9.jpg", caption: "2024"},
    {id: 47, src: "../assets/images/2024g3.jpg", caption: "2024"},
    {id: 48, src: "../assets/images/2024g4.jpg", caption: "2024"},
    {id: 49, src: "../assets/images/2024g5.jpg", caption: "2024"},
    {id: 50, src: "../assets/images/2024g6.jpg", caption: "2024"},
    {id: 51, src: "../assets/images/2024g7.jpg", caption: "2024"},
    {id: 54, src: "../assets/images/2024g10.jpg", caption: "2024"},
    {id: 55, src: "../assets/images/2024g11.jpg", caption: "2024"},
    {id: 43, src: "../assets/images/2023.jpg", caption: "2023"},
    {id: 52, src: "../assets/images/2024g8.jpg", caption: "2024"},
    {id: 44, src: "../assets/images/2024.jpg", caption: "2024"},
    {id: 39, src: "../assets/images/2019.jpg", caption: "2019"},
    {id: 37, src: "../assets/images/2018.jpg", caption: "2018"},
    {id: 38, src: "../assets/images/2018anotherpic.jpg", caption: "2018"},
    {id: 35, src: "../assets/images/2016.jpg", caption: "2016"},
    {id: 36, src: "../assets/images/2017.jpg", caption: "2017"},
    {id: 33, src: "../assets/images/2015.jpg", caption: "2015"},
  ]);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  return (
    <div>
      <h1
        className="animate__animated animate__zoomIn"
        style={{
          textAlign: "center",
          marginTop: "20px",
          color: "#ffffff",
        }}>
        Gallery
      </h1>
      <div className={Styles.gallery}>
        {images.map((image) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.caption}
            onClick={() => handleImageClick(image)}
          />
        ))}
      </div>
      {selectedImage && (
        <div className={Styles.modal}>
          <div className={Styles.modal_content}>
            <img src={selectedImage.src} alt={selectedImage.caption} />
            <p>{selectedImage.caption}</p>
            <button onClick={() => setSelectedImage(null)}>Close</button>
          </div>
        </div>
      )}
              
       <Link to="/sanjhauli/Gallery" className={Styles.btn}>
        <Next_Btn />
      </Link>
    </div>
  );
};
